import {Model} from 'MWC';

const installment_from_statement = 'installment_from_statement',
    installment_from_statement_two = 'installment_from_statement_two',
    oneTimeCommission = 'one_time_commission',
    timeUnit = 'time_unit',
    realRate = 'real_rate',
    months = 12,
    hundredPercent = 100,
    daysInTheYear = 365,
    bankDays = 360;

export default class extends Model {
    static fields;

    constructor(data, selectedType) {
        super();
        this.selectedType = selectedType;
        this.creditSum = data[selectedType].min;
        this.loanTerm = 0;
        this.requiredPayment = 0;
        this.overpayment = 0;
        this.creditCost = 0;
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            installment_from_statement: data[installment_from_statement],
            installment_from_statement_two: data[installment_from_statement_two]
        };
    }

    switchType(type) {
        this.selectedType = type;

        this.creditSum = this.getMinSumEdge();
        this.loanTerm = 0;

        this.calculateIndicators();
    }

    getCalculatorType() {
        return this.selectedType;
    }

    changeField(name, value) {
        this[name] = value;
        this.calculateIndicators();
    }

    getTypeFields() {
        return this.fields[this.getCalculatorType()];
    }

    getCreditSum() {
        return +this.creditSum;
    }

    setCreditSum(value) {
        this.creditSum = value;
    }

    getMinSumEdge() {
        return +this.getTypeFields().min;
    }

    getFixAmounts() {
        return this.getTypeFields().fix_amounts;
    }

    getMaxSumEdge() {
        return +this.getTypeFields().max;
    }

    getSumStep() {
        return +this.getTypeFields().step;
    }

    getTerms() {
        return this.getTypeFields().terms;
    }

    getCurrentLoanTerm() {
        return this.loanTerm;
    }

    getMinTermEdge() {
        return this.getTerms()[0];
    }

    getMaxTermEdge() {
        const terms = this.getTerms();
        return terms[terms.length - 1];
    }

    setCurrentLoanTerm(value) {
        this.loanTerm = value;
    }

    getTimeUnit() {
        return this.getTypeFields()[timeUnit];
    }

    getCreditTerm() {
        return +this.getTerms()[this.getCurrentLoanTerm()];
    }

    getCoefficient() {
        return this.getTypeFields().coefficient[this.getCurrentLoanTerm()];
    }

    getMaxDays() {
        const maxDays = this.getTypeFields().max_days;

        if (!maxDays) {
            return null;
        }

        return maxDays[this.getCurrentLoanTerm()] || null;
    }

    getCreditRate() {
        return this.getTypeFields().rate;
    }

    getRealRate() {
        return this.getTypeFields()[realRate][this.getCurrentLoanTerm()];
    }

    getRate() {
        return this.getTypeFields().rate;
    }

    getMonthCommission() {
        return this.getTypeFields().month_commission;
    }

    getOneTimeCommission() {
        return this.getTypeFields()[oneTimeCommission];
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    setRequiredPayment(value) {
        this.requiredPayment = value;
    }

    getOverpayment() {
        return this.overpayment;
    }

    setOverpayment(value) {
        this.overpayment = value;
    }

    getCreditCost() {
        return this.creditCost;
    }

    setCreditCost(value) {
        this.creditCost = value;
    }

    calculateCreditSum() {
        const creditSum = this.getCreditSum();
        return +creditSum + (creditSum * this.getOneTimeCommission()) / hundredPercent;
    }

    resetIndicators() {
        this.setCreditSum(this.getMinSumEdge());
        this.setCurrentLoanTerm(0);
    }

    _round2(value) {
        return Math.round(value * 100) / 100;
    }

    calculateIndicators() {
        const creditSum = this.calculateCreditSum();
        const coefficient = this.getCoefficient();
        const term = this.getCreditTerm();

        if (coefficient == null || coefficient <= 0) {
            console.error('Invalid coefficient for term', term);
            return;
        }

        const rawRequiredPayment = creditSum * coefficient;
        const requiredPayment = this._round2(rawRequiredPayment);

        const rawTotal = rawRequiredPayment * term;

        const overpayment = this._round2(rawTotal - creditSum);

        const creditCost = this._round2(rawTotal);

        this.setRequiredPayment(requiredPayment);
        this.setOverpayment(overpayment);
        this.setCreditCost(creditCost);
    }
}
